import { Routes } from '@angular/router';

export enum MyInvoicesRouteIds {
  INVOICE_ID = 'invoiceId',
}
export enum MyInvoicesRoutesName {
  BILLING_REPORT = 'billing-report',
}
export const MY_INVOICES_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'listing',
  },
  {
    path: 'listing',
    loadComponent: () => import('@pages/my-invoices/my-invoices-listing/my-invoices-listing.page').then((p) => p.MyInvoicesListingPage),
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: MyInvoicesRoutesName.BILLING_REPORT,
    loadComponent: () => import('@pages/my-invoices/billing-report/billing-report.page').then((p) => p.BillingReportPage),
    data: {
      breadcrumb: 'ACTIONS.BILLING_REPORTS',
    },
  },
  {
    path: `:${MyInvoicesRouteIds.INVOICE_ID}`,
    loadComponent: () => import('@pages/my-invoices/individual-invoice/individual-invoice.page').then((p) => p.IndividualInvoicePage),
    data: {
      breadcrumb: (resolvedId: string) => resolvedId,
    },
  },
];
